// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
    padding: 28px 32px 20px 32px;
  `,
);
